module.exports = __webpack_public_path__ + "img/banner_account.7f2b5399.png";